module.exports = __webpack_public_path__ + "public/images/default_avatar.c416a877a4db00e4d5701a43b2401a6c.png";